import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';

export const Text = styled(Typ30)`
  margin: 8px 0 18px;
  width: 100%;
`;

export const Button = styled(Btn021)`
  margin-bottom: 62px;
  width: 100%;
`;
